import { ErrorHandlerProps } from "./ErrorHandlerTypes";

const ErrorHandler: React.FC<ErrorHandlerProps> = ({ error, message }) => {
  const defaultErrorMessage = "Någonting gick fel..";
  console.error(error);

  return (
    <div className="error-handler" role="alert">
      {message || defaultErrorMessage}
    </div>
  );
};

export default ErrorHandler;
